<app-dialog
  customClass="onboarding-stripe-wrapper"
  [dialogType]="dialogType"
  [stackActions]="true"
  [primaryActionText]="'DIALOG.PAYMENTS.LABEL.CONNECT_WITH_STRIPE' | translate"
  [secondaryActionText]="'DIALOG.PAYMENTS.LABEL.LEARN_MORE' | translate"
  [primaryActionDisabled]="!underwritingUrl"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="primaryActionTappedTrackingAction"
  [secondaryActionTapped]="secondaryActionTappedTrackingAction"
  (onPrimaryAction)="goToStripe()"
  (onSecondaryAction)="goToLearnMore()"
>
  <div class="onboarding-stripe-dialog">
    <app-icon
      class="underwriting-stripe-canvas-icon"
      [icon]="underwritingStripeCanvasIcon"
    >
    </app-icon>

    <div class="contents">
      <div class="title">
        {{ 'DIALOG.PAYMENTS.HEADER.STRIPE_ONBOARDING' | translate }}
      </div>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_1' | translate }}
      </p>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_2' | translate }}
      </p>

      <app-checkmark-list class="checkmark-list" [items]="listItems">
      </app-checkmark-list>
    </div>
  </div>
</app-dialog>
